<template>
  <v-container
    fluid
    class="overlay"
  >
    <v-layout
      align-center
      justify-center
      column
    >
      <v-flex class="saving center">
        <h3>{{ strings.saving }}</h3>
      </v-flex>
      <v-flex class="saving">
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  ...mapGetters("page", ["strings"])
};
</script>

<style lang="less" scoped>
.overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #a0a0a0a0;
}

.overlay .saving {
  background-color: #fffffff7;
  padding: 1%;
  width: 50vw;
  height: 15vh;
  color: #005387;
}

.overlay .saving.center {
  margin-top: 40vh;
}

.overlay .saving-icon {
  background-color: #fffffff7;
  padding: 1%;
  color: #005387;
}
</style>
